import { JOB_STATES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(JOB_STATES_ENDPOINT);
export default instance;
